module.exports = {"failed":"Ingreso fallido","success":"Ingreso exitoso"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/es/auth.json
// module id = 724
// module chunks = 18